import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import * as yup from "yup";
import { TabView, TabPanel } from "primereact/tabview";
import { Editor } from "primereact/editor";
import { DialogActions, InputAdornment, Typography } from "@material-ui/core";
import { Card } from "react-bootstrap";
import Swal from "sweetalert2";
import { DateTime } from "luxon";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import {
  FormArrayTextField,
  FormDateField,
  FormOutlinedNoMarginTextField,
  FormSelectField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import Illustration from "../../../../partials/content/Illustration";
import DeliveryService from "../../inventory/stock-management/delivery/deliveryService";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchWarehouse from "../../inventory/warehouses/searchWarehouse";
import SearchSalesOrder from "../salesOrder/searchSalesOrder";
import MapPlaces from "../../../../partials/content/MapPlaces";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import ContentLayout from "../../../../partials/content/ContentLayout";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import {
  getItemsToDeliverFromSalesOrder,
  getSoDeliveryDetail,
  saveSoDeliveryOrder,
} from "../../../../services/sales/salesDeliveryService";
import AppForm from "../../../../partials/content/Forms/AppForm";
const deliveryFormSchema = yup.object().shape({
  ID: yup.number(),
  salesOrderID: yup.number(),
  customerID: yup.number(),
  customerName: yup.string().required("Customer Name is required"),
  warehouseName: yup.string().required("Warehouse Name is required"),
  deliveryDate: yup.date().required(),
  recipient: yup
    .string()
    .required("Ship To is required")
    .max(255, "Ship To maximum characters is 255"),
  address: yup
    .string()
    .required("Address is required")
    .max(255, "Address maximum characters is 255"),
  city: yup
    .string()
    .required("City is required")
    .max(50, "City maximum characters is 50"),
  addressPhone: yup
    .string()
    .required("Phone Number is required")
    .matches(
      /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
      "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
    )
    .max(50, "Phone Number maximum characters is 50"),
  addressEmail: yup
    .string()
    .email("Email must be valid. e.g. joe@invifo.com")
    .max(50, "Email maximum characters is 50"),
  province: yup.string().max(50, "Province maximum characters is 50"),
  countryCode: yup.string(),
  postalCode: yup.string().max(10, "Postal Code maximum characters is 10"),
  deliveryItem: yup
    .array()
    .of(
      yup.object().shape({
        ID: yup.number(),
        itemID: yup.number(),
        itemName: yup.string(),
        varCode: yup.string(),
        batchID: yup.number(),
        qtyToDeliver: yup.number().required(),
        uomID: yup.number(),
        uomName: yup.string(),
        send: yup.bool(),
      })
    )
    .nullable(),
});
function DeliveryOrderForm({ history, match }) {
  const { deliveryID = 0 } = match.params;
  const { reload } = useGlobalData();
  const { companyProfile } = useGlobalData();
  const [countries, setCountries] = useState([]);
  const [delivery, setDelivery] = useState({
    ID: 0,
    docRef: "SO",
    deliveryDocRef: "",
    invoiceID: 0,
    customerID: 0,
    customerName: "",
    salesOrderID: 0,
    salesReturnID: 0,
    salesOrderCode: "",
    operationCardID: 0,
    salesPosID: 0,
    warehouseID: 0,
    warehouseName: "",
    currencyID: 0,
    currencyCode: "",
    deliveryCost: 0,
    deliveryDate: DateTime.now().startOf("day"),
    recipient: "",
    address: "",
    city: "",
    province: "",
    postalCode: "",
    addressPhone: "",
    addressEmail: "",
    countryCode: companyProfile.countryCode,
    countryName: "",
    note: "",
    fiscalYear: 0,
    fiscalPeriod: 0,
    deliveryItem: [],
    deliveryService: [],
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  });

  useEffect(() => {
    if (deliveryID > 0) {
      getSoDeliveryDetail(deliveryID).then((response) => {
        const { data } = response.data;
        setDelivery(data.soDelivery);
      });
    }
  }, [deliveryID, reload]);
  return (
    <ContentLayout>
      <AppForm
        initialValues={delivery}
        validationSchema={deliveryFormSchema}
        onSubmit={async (values, { setStatus, setSubmitting }) => {
          values.warehouseID = parseInt(values.warehouseID);
          values.deliveryCost = parseFloat(values.deliveryCost);
          let itemSendFound = true;
          /*
          for (const delItem of values.deliveryItem) {
            if (delItem.send) {
              itemSendFound = true;
              break;
            }
          }

          for (const service of values.deliveryService) {
            service.qty = parseFloat(service.qty);
            if (service.qty > 0) {
              itemSendFound = true;
            }
          }
            */
          if (itemSendFound) {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            })
              .fire({
                title: "Are you sure want to save this Delivery ?",
                text: "Please note that you are responsible for this action",
                icon: "question",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
                cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                reverseButtons: true,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  const deliveryOrder = { ...values };
                  for (const item of deliveryOrder.deliveryItem) {
                    item.qtyToDeliver = parseFloat(item.qtyToDeliver);
                  }
                  saveSoDeliveryOrder(deliveryOrder).then((response) => {
                    Swal.mixin({
                      customClass: {
                        confirmButton:
                          "btn btn-success btn-md btn-pill btn-bold",
                      },
                      buttonsStyling: false,
                    }).fire({
                      title: "Saved",
                      html: response.data.message,
                      icon: "success",
                      showCloseButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                    });
                    history.push("/sales/delivery-order");
                  });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Cancelled",
                    text: "No change has been made",
                    icon: "info",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                }
              });
          } else {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Failed",
              text:
                "Please select the items or fill service quantity which need to be delivered",
              icon: "error",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
          }
        }}
      >
        <DeliveryOrderFormContent history={history} setDelivery={setDelivery} />
      </AppForm>
    </ContentLayout>
  );
}

const DeliveryOrderFormContent = ({ history, setDelivery }) => {
  const [openSearchDocRef, setOpenSearchDocRef] = useState(false);
  const [openSearchWarehouse, setOpenSearchWarehouse] = useState(false);
  const [itemsReadyToDeliver, setItemsReadyToDeliver] = useState([]);
  const [openSearchMapPlaces, setOpenSearchMapPlaces] = useState(false);
  const { values, setFieldValue, handleSubmit, errors } = useFormikContext();
  return (
    <React.Fragment>
      <PageSubHeader
        title="Delivery Order Form"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/delivery-order",
            title: "Delivery Order List",
            active: false,
          },
          {
            page: "/sales/delivery-order-form",
            title: "Delivery Order Form",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/menu");
            },
          },
          {
            title: "Save",
            color: "success",
            icon: "fas fa-save",
            onClick: (e) => {
              handleSubmit(e);
            },
          },
        ]}
      />
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="Delivery Main" rightIcon="fas fa-th-large">
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Delivery Header</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <FormTextField
                            label="Warehouse Name"
                            name="warehouseName"
                            searchButton
                            readonly
                            onSearchClick={() => {
                              setOpenSearchWarehouse(true);
                            }}
                          />
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormTextField
                                label="Document Reference"
                                name="deliveryDocRef"
                                searchButton
                                readonly
                                onSearchClick={() => {
                                  setOpenSearchDocRef(true);
                                }}
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormTextField
                                label="Sales Order ID"
                                name="salesOrderCode"
                                readonly
                              />
                            </div>
                          </div>
                          <FormTextField
                            label="Customer Name"
                            name="customerName"
                            readonly
                          />
                          <FormDateField
                            label="Delivery Date"
                            name="deliveryDate"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <FormTextField
                            label="Currency"
                            name="currencyCode"
                            readonly
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <FormTextField
                            label="Delivery Cost"
                            name="deliveryCost"
                            currencyField
                            currencyCode={values.currencyCode}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-map-marked-alt"></i>
                      <span>
                        <strong>Shipping Address</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <FormTextField label="Ship To" name="recipient" />
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormTextField
                                label="Address"
                                name="address"
                                mapsButton
                                onMapsClick={() => {
                                  setOpenSearchMapPlaces(true);
                                }}
                              />
                              <FormTextField label="City" name="city" />
                              <FormTextField
                                label="Province / State"
                                name="province"
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormTextField
                                label="Phone Number"
                                name="addressPhone"
                              />
                              <FormTextField
                                label="Email"
                                name="addressEmail"
                              />
                              <FormTextField
                                label="Postal Code"
                                name="postalCode"
                              />
                            </div>
                          </div>
                          <FormSelectField
                            label="Country"
                            name="countryCode"
                            options={[]}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Delivery Item" rightIcon="fas fa-stream">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="card">
                    {(itemsReadyToDeliver && itemsReadyToDeliver.length > 0) ||
                    (values.deliveryItem && values.deliveryItem.length > 0) ? (
                      <div className="py-3">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Item Name</th>
                              <th>Qty</th>
                              <th style={{ width: "20%" }}>Qty to Deliver</th>
                              <th>Unit</th>
                            </tr>
                          </thead>
                          <tbody>
                            {values.deliveryItem.map((item, index) => (
                              <tr key={index}>
                                <td>
                                  <FormOutlinedNoMarginTextField
                                    value={`${item.itemCode} ${item.itemName}`}
                                    InputProps={{
                                      startAdornment:
                                        item.itemType > 0 ? (
                                          <InputAdornment position="start">
                                            <BootstrapTooltip
                                              title={item.itemTypeName}
                                            >
                                              <i
                                                className={
                                                  item.itemType === 1
                                                    ? "fas fa-boxes text-success"
                                                    : item.itemType === 2
                                                    ? "fas fa-tools text-primary"
                                                    : item.itemType === 3
                                                    ? "fas fa-building text-info"
                                                    : item.itemType === 4
                                                    ? "fas fa-boxes text-warning"
                                                    : item.itemType === 5
                                                    ? "fas fa-boxes text-danger"
                                                    : null
                                                }
                                              ></i>
                                            </BootstrapTooltip>
                                          </InputAdornment>
                                        ) : null,
                                      readOnly: true,
                                    }}
                                  />
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName="deliveryItem"
                                    index={index}
                                    propName="qty"
                                    quantityField
                                    margin="none"
                                    readonly
                                  />
                                </td>
                                <td>
                                  <FormArrayTextField
                                    index={index}
                                    arrayPropName="deliveryItem"
                                    propName="qtyToDeliver"
                                    margin="none"
                                  />
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName="deliveryItem"
                                    index={index}
                                    propName="uomName"
                                    margin="none"
                                    readonly
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="py-3">
                        <Illustration
                          imageSource="INVIFO Sales.png"
                          description={`No available Item which ready to be delivered yet!`}
                          guidance="Hint: once the sales order items has been prepared and reserved, it will be displayed here"
                          descriptionLeftIcon="fas fa-info-circle kt-font-warning"
                          size="md"
                        ></Illustration>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Delivery Service" rightIcon="fas fa-stream">
              <DeliveryService />
            </TabPanel>
            <TabPanel header={"Note"} rightIcon="fas fa-sticky-note">
              <Editor
                style={{ height: "200px", width: "100%" }}
                onTextChange={(e) => {
                  setFieldValue("note", e.htmlValue);
                }}
                value={values.note}
                placeholder="Type your notes here..."
              />
            </TabPanel>
          </TabView>
        </div>
        <DialogLayout
          open={openSearchWarehouse}
          title="Search Warehouse"
          onCloseDialog={() => {
            setOpenSearchWarehouse(false);
          }}
          maxWIdth="md"
        >
          <SearchWarehouse
            onSelectWarehouse={(warehouse) => {
              setFieldValue("warehouseID", warehouse.ID);
              setFieldValue("warehouseName", warehouse.warehouseName);
              setOpenSearchWarehouse(false);
            }}
          />
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={() => {
                setOpenSearchWarehouse(false);
              }}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
          </DialogActions>
        </DialogLayout>
        <DialogLayout
          open={openSearchDocRef}
          title="Search Document Reference"
          onCloseDialog={() => {
            setOpenSearchDocRef(false);
          }}
          minHeight={true}
        >
          <div className="tabview">
            <div className="card">
              <TabView>
                <TabPanel header="Sales Order" rightIcon="fas fa-tags">
                  <SearchSalesOrder
                    giStatus="12"
                    reserveStatus="0"
                    showAmount={false}
                    onSelectSalesOrder={(salesOrder) => {
                      getItemsToBeDeliveredFromSalesOrderData(
                        salesOrder.ID,
                        values
                      );
                      setOpenSearchDocRef(false);
                    }}
                  />
                </TabPanel>
              </TabView>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={() => {
                setOpenSearchDocRef(false);
              }}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
          </DialogActions>
        </DialogLayout>
        <DialogLayout
          open={openSearchMapPlaces}
          title="Search Address on Maps"
          onCloseDialog={() => {
            setOpenSearchMapPlaces(false);
          }}
          maxWIdth="lg"
          minHeight={true}
        >
          <MapPlaces
            address={values.address}
            city={values.city}
            province={values.province}
            countryCode={values.countryCode}
            postalCode={values.postalCode}
            onPinLocation={(
              selectedFormattedAddress,
              selectedShortAddressComponents,
              selectedLongAddressComponents,
              selectedAddress,
              selectedCity,
              selectedProvince,
              selectedCountryCode,
              selectedPostalCode
            ) => {
              setFieldValue(`address`, selectedAddress);
              setFieldValue(`city`, selectedCity);
              setFieldValue(`province`, selectedProvince);
              setFieldValue(`countryCode`, selectedCountryCode);
              setFieldValue(`postalCode`, selectedPostalCode);
              setOpenSearchMapPlaces(false);
            }}
            onCloseDialog={() => {
              setOpenSearchMapPlaces(false);
            }}
          />
        </DialogLayout>
      </div>
    </React.Fragment>
  );

  async function getItemsToBeDeliveredFromSalesOrderData(
    salesOrderID = 0,
    values
  ) {
    const response = await getItemsToDeliverFromSalesOrder(salesOrderID);
    const { data } = response.data;
    const { salesOrder, serviceItems, countries } = data;

    let deliveryItem = [];
    let serviceItemsData = [];
    for (const soItem of salesOrder.salesOrderItem) {
      deliveryItem.push({
        ID: 0,
        salesOrderID: soItem.salesOrderID,
        salesOrderItemID: soItem.ID,
        operationStockID: 0,
        itemID: soItem.itemID,
        itemType: soItem.itemType,
        itemTypeName: soItem.itemTypeName,
        itemCode: soItem.itemCode,
        itemName: soItem.itemName,
        varCode: soItem.varCode,
        batchID: soItem.batchID,
        qty: soItem.qty,
        qtyToDeliver: soItem.qty,
        uomID: soItem.uomID,
        uomName: soItem.uom.uomName,
        send: true,
      });
    }

    for (const service of serviceItems) {
      serviceItemsData.push({
        timeSheetID: 0,
        deliveryID: 0,
        salesOrderID: service.salesOrderID,
        salesOrderItemID: service.ID,
        salesPosID: 0,
        salesPosItemID: 0,
        timeSheetDate: 0,
        itemID: service.itemID,
        itemType: service.itemType,
        itemTypeName: service.itemTypeName,
        serviceCode: service.itemCode,
        serviceName: service.itemName,
        varCode: service.varCode,
        qty: 0,
        qtyOrder: service.qty,
        uomID: service.uomID,
        uomName: service.uomName,
      });
    }
    setDelivery({
      ID: 0,
      docRef: "SO",
      deliveryDocRef: "Sales Order",
      invoiceID: 0,
      salesOrderID: salesOrder.ID,
      salesOrderCode: salesOrder.salesOrderCode,
      operationCardID: 0,
      salesPosID: 0,
      customerID: salesOrder.customerID,
      customerName: salesOrder.customer.customerName,
      warehouseID: values.warehouseID,
      warehouseName: values.warehouseName,
      resiNo: "",
      deliveryDate: DateTime.now().startOf("day"),
      currencyID: salesOrder.currencyID,
      currencyCode: salesOrder.currency.currencyCode,
      deliveryCost: 0,
      driverName: "",
      recipient: salesOrder.customer.customerName,
      address: salesOrder.soDeliveryAddress.address,
      city: salesOrder.soDeliveryAddress.city,
      province: salesOrder.soDeliveryAddress.province,
      postalCode: salesOrder.soDeliveryAddress.postalCode,
      addressPhone: salesOrder.soDeliveryAddress.addressPhone,
      addressEmail: salesOrder.soDeliveryAddress.addressEmail,
      countryCode: salesOrder.soDeliveryAddress.countryCode,
      countryName: salesOrder.soDeliveryAddress.countryName,
      note: "",
      deliveryItem,
      deliveryService: serviceItemsData,
    });
    //setCountries(countries);
  }
};

export default DeliveryOrderForm;
